import React, { Component } from 'react';
import { Col, FormGroup, Label, Input, Row } from 'reactstrap';
import { connect } from 'react-redux';
import DropdownSelect from './ProposalGenerator/DropdownSelect';
import { addCompanyChange } from '../actions/Companies';
import TemplateAutoComplete from './TemplateAutocomplete';
import { getTemplates } from '../actions/ModifyProducts';
import { STATE_OPTIONS } from '../utils/constants';
import Toggle from './Toggle';
import MultiInput from './MultiInput';
import util from '../lib/utils';
import { COMPANY_TYPE_DROPDOWN } from '../lib/constants';
import Location from '../components/Location/index'
import AlertFaxDownloadModal from './AlertFaxDownloadModal';
class AddCompanyForm extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken');
    this.state = {
      address1: props.comingFrom === 'edit' ? props?.editData?.companyLocation?.address1 ?? '' : '',
      address2: props.comingFrom === 'edit' ? props?.editData?.companyLocation?.address2 ?? '' : '',
      city: props.comingFrom === 'edit' ? props?.editData?.companyLocation?.city ?? '' : '',
      state: props.comingFrom === 'edit' ? props?.editData?.companyLocation?.state ?? '' : '',
      zip: props.comingFrom === 'edit' ? props?.editData?.companyLocation?.zip ?? '' : '',
      companyGroupName: props.editData?.companyGroups?.map(val => val?.name || '-'),
      productGroupTemplate:
        props.comingFrom === 'edit' ? props?.editData?.productGroupTemplate?.templateName : '',
      templateId: '',
      companyId: props.comingFrom === 'edit' ? props.editData._id : null,
      epikCustomerId: props.comingFrom === 'edit' ? props.editData.epikCustomerId : '',
      selectType:
        props.comingFrom === 'edit'
          ? this.getCompanyType(props.editData.companyType)
          : COMPANY_TYPE_DROPDOWN[0],
      name: props.comingFrom === 'edit' ? props.editData.name : props.name,
      status: props.comingFrom === 'edit' ? props.editData.enabled : props.status,
      permissions: {
        emailNotifications:
          props.comingFrom === 'edit' ? props.editPermissions.emailNotifications : false,
        showCallRecording:
          props.comingFrom === 'edit' ? props.editPermissions.showCallRecording : false,
        showFaxDownload:
          props.comingFrom === 'edit' ? props.editPermissions.showFaxDownload : false,
      },
      contactPerson: {
        email: '',
        name: '',
        phone: '',
      },
      contactEmails: props.comingFrom === 'edit' ? props.editData.contactEmails : [],
    };
    this.onEnabledChange = this.onEnabledChange.bind(this);
  }

  getCompanyType = e => {
    const selectedType = COMPANY_TYPE_DROPDOWN.filter(item => item.value === e);
    return selectedType[0];
  };

  componentDidMount() {
    const { comingFrom, editData, editPermissions, getTemplates } = this.props;
    const { contactPerson, permissions } = this.state;

    getTemplates(this.token, 'productGroup');
    this.props.addCompanyChange({
      name: 'companyType',
      value: COMPANY_TYPE_DROPDOWN[0].value,
    });
    if (comingFrom === 'edit') {
      this.props.addCompanyChange({
        name: 'showFaxDownload',
        value: editPermissions.showFaxDownload,
      });
      this.props.addCompanyChange({
        name: 'emailNotifications',
        value: editPermissions.emailNotifications,
      });
      this.props.addCompanyChange({
        name: 'showCallRecording',
        value: editPermissions.showCallRecording,
      });
      permissions.showFaxDownload = editPermissions.showFaxDownload;
      permissions.emailNotifications = editPermissions.emailNotifications;
      permissions.showCallRecording = editPermissions.showCallRecording;
      this.props.addCompanyChange({
        name: 'name',
        value: editData?.contactPerson?.name || '',
        type: 'contactPerson',
      });
      this.props.addCompanyChange({
        name: 'email',
        value: editData?.contactPerson?.email || '',
        type: 'contactPerson',
      });
      this.props.addCompanyChange({
        name: 'phone',
        value: editData?.contactPerson?.phone || '',
        type: 'contactPerson',
      });
      this.props.addCompanyChange({
        name: 'contactEmails',
        value: editData?.contactEmails || [],
      });
      contactPerson['name'] = editData?.contactPerson?.name || '';
      contactPerson['email'] = editData?.contactPerson?.email || '';
      contactPerson['phone'] = editData?.contactPerson?.phone || '';
      this.props.addCompanyChange({
        name: 'address1',
        value: editData?.companyLocation?.address1 || '',
        type: 'companyLocation',
      });
      this.props.addCompanyChange({
        name: 'address2',
        value: editData?.companyLocation?.address2 || '',
        type: 'companyLocation',
      });
      this.props.addCompanyChange({
        name: 'zip',
        value: editData?.companyLocation?.zip || '',
        type: 'companyLocation',
      });
      this.props.addCompanyChange({
        name: 'state',
        value: editData?.companyLocation?.state || '',
        type: 'companyLocation',
      });
      this.props.addCompanyChange({
        name: 'city',
        value: editData?.companyLocation?.city || '',
        type: 'companyLocation',
      });
      this.setState({ contactPerson, permissions });
    }
  }

  onAddedCompanyChange = ev => {
    const { name, value } = ev.target;
    this.setState({ [name]: value });
    this.props.addCompanyChange({ name, value });
  };

  onAddCompanyLocation = ev => {
    const { name, value } = ev.target;
    this.setState({ [name]: value });
    this.props.addCompanyChange({ name, value, type: 'companyLocation' });
  };

  onContactPersonChange = ev => {
    const { name, value } = ev.target;
    const { contactPerson } = this.state;
    contactPerson[name] = value;
    this.setState({ contactPerson });
    this.props.addCompanyChange({ name, value, type: 'contactPerson' });
  };

  onEnabledChange(value) {
    this.props.addCompanyChange({ name: 'enabled', value: !value });
    this.setState({ status: !value });
  }

  onFaxDownloadChange = value => {
    this.props.addCompanyChange({ name: 'showFaxDownload', value: !value });
    const { permissions } = this.state;
    permissions.showFaxDownload = !value;
    this.setState({ permissions });
    if (!value) {
      // If the Fax Download Option is being enabled, open the modal
      this.toggleAlertModal();
    }
  };
  toggleAlertModal = () => {
    this.setState((prevState) => ({
      isAlertModalOpen: !prevState.isAlertModalOpen,
    }));
  };

  onEnabledNotificationChange = value => {
    this.props.addCompanyChange({ name: 'emailNotifications', value: !value });
    const { permissions } = this.state;
    permissions.emailNotifications = !value;
    this.setState({ permissions });
  };

  onEnabledCallRecordings = value => {
    this.props.addCompanyChange({ name: 'showCallRecording', value: !value });
    const { permissions } = this.state;
    permissions.showCallRecording = !value;
    this.setState({ permissions });
  };

  onTypeSelect = selectedOption => {
    const { value } = selectedOption;
    this.props.addCompanyChange({ name: 'companyType', value });
  };

  onEmailsChange(emails) {
    const { addCompanyChange } = this.props;
    const target = {
      name: 'contactEmails',
      value: emails,
    };
    this.setState(
      {
        contactEmails: emails,
      },
      () => {
        addCompanyChange(target);
      },
    );
  }

  getLocationInfo = ev => {
    const propertyNames = ['address', 'address2', 'zip', 'state', 'city', 'country'];

    propertyNames.forEach((name) => {
      this.props.addCompanyChange({
        name: name === 'address' ? 'address1' : name,
        value: ev?.[name] || '',
        type: 'companyLocation',
      });
    });
  }

  render() {
    const { isAlertModalOpen } = this.state;

    const formData = {
      city: this.state?.city || '',
      state: this.state?.state || '',
      address1: this.state?.address1 || '',
      address2: this.state?.address2 || '',
      zip: this.state?.zip || '',
    }

    return (
      <div className="container">
        <FormGroup row>
          <Label for="name" sm={4}>
            Customer ID:
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="text"
              name="epikCustomerId"
              value={this.state.epikCustomerId}
              onChange={this.onAddedCompanyChange}
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label for="name" sm={4}>
            Company Name:
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="text"
              name="name"
              value={this.state.name}
              onChange={this.onAddedCompanyChange}
            />
          </Col>
        </FormGroup>
        <Location
          disabled={false}
          boxDbLocation={formData}
          getLocationInfo={this.getLocationInfo}
          latLang={false}
          address2={true}
        />
        {/* <FormGroup row>
          <Label for="name" sm={4}>
            Address 1:
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="text"
              name="address1"
              value={this.state.address1}
              onChange={this.onAddCompanyLocation}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="name" sm={4}>
            Address 2:
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="text"
              name="address2"
              value={this.state.address2}
              onChange={this.onAddCompanyLocation}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="name" sm={4}>
            City:
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="text"
              name="city"
              value={this.state.city}
              onChange={this.onAddCompanyLocation}
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label for="name" sm={4}>
            State :
          </Label>
          <Col sm={12}>
            <Input
              required
              type="select"
              name="state"
              value={this.state.state}
              onChange={this.onAddCompanyLocation}
            ><option value="" hidden>Please specify</option>
              {
                STATE_OPTIONS.map(({ label, value }) => {
                  return <option value={value}> {label}</option>;
                })
              }
            </Input>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="name" sm={4}>
            Zip :
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="text"
              name="zip"
              value={this.state.zip}
              onChange={this.onAddCompanyLocation}
            />
          </Col>
        </FormGroup> */}
        <FormGroup row>
          <Label sm={4}>Type:</Label>
          <Col sm={12} style={{ display: 'flex', verticalAlign: 'middle' }}>
            <DropdownSelect
              options={COMPANY_TYPE_DROPDOWN}
              selectedOption={this.state.selectType}
              onSelect={this.onTypeSelect}
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label for="name" sm={12}>
            Contact Person Name:
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="text"
              name="name"
              value={this.state.contactPerson.name}
              onChange={this.onContactPersonChange}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="name" sm={4}>
            Email:
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="text"
              name="email"
              value={this.state.contactPerson.email}
              onChange={this.onContactPersonChange}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="name" sm={4}>
            Phone Number:
          </Label>
          <Col sm={12}>
            <Input
              placeholder="Please specify"
              required
              type="number"
              name="phone"
              value={this.state.contactPerson.phone}
              onChange={this.onContactPersonChange}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="name" sm={4}>
            Select template:
          </Label>
          <Col sm={12}>
            <TemplateAutoComplete
              searchTerm={this.state.productGroupTemplate}
              templates={this.props.productGroupTemplate}
              onChange={e =>
                e.suggestion !== null
                  ? this.props.addCompanyChange({
                      name: 'productGroupTemplate',
                      value: e.suggestion._id,
                    })
                  : ''
              }
            />
          </Col>
        </FormGroup>
        <Row>
          <Col sm={6}>
            <FormGroup row>
              <Label for="enabled" sm={4}>
                Status:
              </Label>
              <Col sm={4} style={{ display: 'flex', verticalAlign: 'middle' }}>
                <Toggle value={this.state.status} onToggle={this.onEnabledChange} />
              </Col>
            </FormGroup>
          </Col>
          <Col sm={6}>
            <FormGroup row>
              <Label for="enabled" sm={12}>
                Fax Download Option:
              </Label>
              <Col sm={4} style={{ display: 'flex', verticalAlign: 'middle' }}>
                <Toggle
                  value={this.state.permissions.showFaxDownload}
                  onToggle={this.onFaxDownloadChange}
                />
              </Col>
            </FormGroup>
          </Col>
          <AlertFaxDownloadModal
            isOpen={isAlertModalOpen}
            onConfirm={() => {
              this.toggleAlertModal(); // Close the modal
            }}
            title="Attention!"
            body="Enabling the Fax Download Option will allow the customer to download any faxes sent on t.37 fax lines. This should not be enabled for customers that need to be HIPAA compliant."
          />

        </Row>

        <FormGroup row>
          <Label for="emailNotifications" sm={6}>
            Email Notifications:
          </Label>
          <Col sm={12} style={{ display: 'flex', verticalAlign: 'middle' }}>
            <Toggle
              value={this.state.permissions.emailNotifications}
              onToggle={this.onEnabledNotificationChange}
            />
          </Col>
        </FormGroup>

        <FormGroup row>
          <Label for="showCallRecording" sm={6}>
            Show Call Recording:
          </Label>
          <Col sm={12} style={{ display: 'flex', verticalAlign: 'middle' }}>
            <Toggle
              value={this.state.permissions.showCallRecording}
              onToggle={this.onEnabledCallRecordings}
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Col sm={12}>
            <hr />
          </Col>
          <Label for="AlertContacts" sm={6}>
            Alert Contacts:
          </Label>
          <Col sm={12}>
            <MultiInput
              placeholder="Enter the email"
              inputData={this.state.contactEmails}
              onChange={this.onEmailsChange.bind(this)}
              validator={util.validateEmail}
            />
          </Col>
        </FormGroup>
        {this.state.companyId !== null ? (
          <FormGroup row>
            <Label for="name" sm={12}>
              Group Management:
            </Label>
            <Col sm={12}>
              <Input
                placeholder="Please specify"
                disabled
                type="text"
                value={this.state.companyGroupName}
              />
            </Col>
          </FormGroup>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    name: state.UIState.companies.addedCompany.name,
    status: state.UIState.companies.addedCompany.enabled,
    editData: state.UIState.companies.editCompanyData,
    editPermissions: state.UIState.companies.editCompanyData.permissions || '',
    productGroupTemplate: state.AppState.modifyProducts.productGroupTemplate,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addCompanyChange: companyData => dispatch(addCompanyChange(companyData)),
    getTemplates: (token, type) => dispatch(getTemplates(token, type)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddCompanyForm);
